import { AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder } from '../encoding/AbstractEncoder.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../modules/SerializersModuleBuilders.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NoOpEncoderClass;
function NoOpEncoder() {
  if (NoOpEncoderClass === VOID) {
    class $ extends AbstractEncoder() {
      static v1z() {
        NoOpEncoder_instance = null;
        var $this = this.b1s();
        NoOpEncoder_instance = $this;
        $this.u1z_1 = EmptySerializersModule();
        return $this;
      }
      x1r() {
        return this.u1z_1;
      }
      d1s(value) {
        return Unit_instance;
      }
      e1s() {
        return Unit_instance;
      }
      f1s(value) {
        return Unit_instance;
      }
      g1s(value) {
        return Unit_instance;
      }
      h1s(value) {
        return Unit_instance;
      }
      i1s(value) {
        return Unit_instance;
      }
      j1s(value) {
        return Unit_instance;
      }
      k1s(value) {
        return Unit_instance;
      }
      l1s(value) {
        return Unit_instance;
      }
      m1s(value) {
        return Unit_instance;
      }
      n1s(value) {
        return Unit_instance;
      }
      o1s(enumDescriptor, index) {
        return Unit_instance;
      }
    }
    initMetadataForObject($, 'NoOpEncoder');
    NoOpEncoderClass = $;
  }
  return NoOpEncoderClass;
}
var NoOpEncoder_instance;
function NoOpEncoder_getInstance() {
  if (NoOpEncoder_instance === VOID)
    NoOpEncoder().v1z();
  return NoOpEncoder_instance;
}
//region block: exports
export {
  NoOpEncoder_getInstance as NoOpEncoder_getInstance2wgh00a9s97su,
};
//endregion

//# sourceMappingURL=NoOpEncoder.mjs.map
